import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { PERIODS } from "../../../../utils";
import {
  dangerousCodes,
  effluentCodes,
  energyFieldMain,
  fuelsCodes,
  kpisCodes,
  kpisFieldMain,
  productionCodes,
  socialCodes,
  wasteCodes,
  waterCodes,
} from "../../../../utils/codes";
import {
  energyCodes,
} from "../../../../utils/dataAndFormulas/energyForms";
import { Productionform } from "../../../../api";
import { useAuth } from "../../../../hooks";
const productionFormController = new Productionform();

export async function reportPdfByYear(data, module, year, t, configFormData = null, siteName = "") {
  const determineKeys = (a) => {
    switch (a) {
      case "social":
        return socialCodes;
      case "energy":
        return energyCodes;
      case "production":
        return productionCodes;
      case "effluent":
        return effluentCodes;
      case "water":
        return waterCodes;
      case "waste":
        return wasteCodes;
      case "kpis":
        return kpisCodes;
      case "dangerous":
        return dangerousCodes;
      case "fuel":
      case "fuels":
        return fuelsCodes;
      default:
        return null;
    }
  };


  // Determinar los campos únicos y si tienen código
  const determineFields = () => {
    const allKeys = Object.keys(determineKeys(module));

    // Si hay configForm con fields configurados, filtrar solo los activos
    if (configFormData && configFormData.fields && configFormData.fields.length > 0) {
      const activeFieldNames = new Set(
        configFormData.fields
          .filter((f) => f.active !== false)
          .map((f) => f.name)
      );
      return allKeys.filter((key) => activeFieldNames.has(key));
    }

    // Sin configuración: mostrar todos
    return allKeys;
  };

  // Retorna el código
  const hasCode = (field) => {
    return determineKeys(module)[field];
  };

  // Obtener todos los campos únicos 
  const uniqueFields = determineFields();

  let uniqueMainFields = [];

  if (module === "energyform") {
    uniqueMainFields = energyFieldMain;
  } else if (module === "kpisform") {
    uniqueMainFields = kpisFieldMain;
  }


  const fmt = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? Math.round(n) : "-";
  };

  const calculateTotalAndAverage = (field) => {
    const values = data.map((item) =>
      item[field]
        ? item[field].value && Number.isFinite(item[field].value)
          ? item[field].value
          : 0
        : 0
    );
    const total = values.reduce((acc, val) => acc + val, 0);
    const average = values.length ? total / values.length : 0;
    return { total: Math.round(total), average: Math.round(average) };
  };

  const dataByPeriods = (field, data) => {
    return PERIODS.map((period) => {
      const item = data.find((d) => d.period === period);
      const raw = item?.[field]?.value;
      return {
        content: raw != null && raw !== "" ? fmt(raw) : "-",
        styles: { valign: "middle", halign: "center" },
      };
    });
  };

  const dataByPeriodsSubFields = (fieldMain, field, data) => {
    return PERIODS.map((period) => {
      const item = data.find((d) => d.period === period);
      const raw = item?.[fieldMain]?.[field]?.value;
      return {
        content: raw != null && raw !== "" ? fmt(raw) : "-",
        styles: { valign: "middle", halign: "center" },
      };
    });
  };

  const getUnit = (field) => {
    if (!Array.isArray(data)) return "-";
    const item = data.find((d) => d?.[field]?.unit);
    return item?.[field]?.unit || "-";
  };

  const getUnitSubfield = (fieldMain, field) => {
    if (!Array.isArray(data)) return "-";
    const item = data.find((d) => d?.[fieldMain]?.[field]?.unit);
    return item?.[fieldMain]?.[field]?.unit || "-";
  };

  const formatDataFields = () => {
    return uniqueFields.map((field) => {
      return [
        {
          content: determineKeys(module)[field],
          styles: { valign: "middle", halign: "center" },
        },
        {
          content: t(field),
          styles: { valign: "middle", halign: "center" },
        },
        { content: getUnit(field), styles: { valign: "middle", halign: "center" } },
        ...dataByPeriods(field, data),
        {
          content: calculateTotalAndAverage(field).total,
          styles: { valign: "middle", halign: "center" },
        },
        {
          content: calculateTotalAndAverage(field).average,
          styles: { valign: "middle", halign: "center" },
        },
      ];
    });
  };


  const formatDataSubfield = (fieldMain) => {

    return uniqueFields.map((field) => {
          return [
            {
              content: determineKeys(module)[field],
              styles: { valign: "middle", halign: "center" },
            },
            {
              content: t(field),
              styles: { valign: "middle", halign: "center" },
            },
            { content: getUnitSubfield(fieldMain, field), styles: { valign: "middle", halign: "center" } },
            ...dataByPeriodsSubFields(fieldMain,field, data),
            {
              content: calculateTotalAndAverage(field).total,
              styles: { valign: "middle", halign: "center" },
            },
            {
              content: calculateTotalAndAverage(field).average,
              styles: { valign: "middle", halign: "center" },
            },
          ];
        })
    
  };

  const formatDataMainField=(fieldMain)=>{
      return [
        {
          content: t(module, fieldMain),
          colSpan: 17,
          //rowSpan: 17,
          styles: {
            valign: "middle",
            fillColor: [244, 247, 249],
            fontStyle: "bold",
          },
        },
      ]
  }

  const dataFinal=()=>{
    if(module==="kpisform" || module ==="energyform"){
      let list=[];
      uniqueMainFields.map(main=>{
        let a=formatDataMainField(main);
        let b=formatDataSubfield(main)
        list.push(a)
        list=list.concat(b)
        return true;
     })
     //console.log(list)
     return list;
    }else{
      return formatDataFields()
    }
  }

  const listPeriods = [];

  const periodsList = PERIODS.map((p) => {
    listPeriods.push({
      content: t(p),
      colSpan: 1,
      styles: {
        valign: "middle",
        fillColor: [244, 247, 249],
        fontStyle: "bold",
      },
    });
  });

  listPeriods.push({
    content: "Total",
    colSpan: 1,
    styles: {
      valign: "middle",
      fillColor: [244, 247, 249],
      fontStyle: "bold",
    },
  });

  listPeriods.push({
    content: "Promedio",
    colSpan: 1,
    styles: {
      valign: "middle",
      fillColor: [244, 247, 249],
      fontStyle: "bold",
    },
  });

  const generatePdf = () => {
    let doc = new jsPDF("l", "pt", "a4", true);
    const totalPaginas = "{total_pages_count_string}";
    const pagActual = 0;
    const pageHeight =
      doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    const pageWidth =
      doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text(
      "REPORTE " + t(module).toLocaleUpperCase(),
      pageWidth / 2,
      50,
      null,
      null,
      "center"
    );
    doc.text("AÑO " + year, pageWidth / 2, 70, null, null, "center");
    if (siteName) {
      doc.setFontSize(12);
      doc.text(siteName.toLocaleUpperCase(), pageWidth / 2, 88, null, null, "center");
      doc.setFontSize(16);
    }

    autoTable(doc, {
      startY: 110,
      head: [
        [
          {
            content: "",
            colSpan: 17,
            styles: { halign: "center", fillColor: [43, 130, 158] },
          },
        ],
      ],
      body: [
        [
          {
            content: "Codigo",
            colSpan: 1,
            rowSpan: 2,
            styles: {
              valign: "middle",
              fillColor: [244, 247, 249],
              fontStyle: "bold",
            },
          },
          {
            content: "Concepto",
            colSpan: 1,
            rowSpan: 2,
            styles: {
              valign: "middle",
              halign: "center",
              fillColor: [244, 247, 249],
              fontStyle: "bold",
            },
          },
          {
            content: "Unidades",
            colSpan: 1,
            rowSpan: 2,
            styles: {
              valign: "middle",
              fillColor: [244, 247, 249],
              fontStyle: "bold",
            },
          },
          {
            content: "Periodo Reporte " + year,
            colSpan: 14,
            styles: {
              valign: "middle",
              fillColor: [244, 247, 249],
              fontStyle: "bold",
              halign: "center",
            },
          },
          //{ content: "CODE", colSpan: 4, styles: { valign: "middle" } }
        ],
        listPeriods,
        ...dataFinal()
        ,
      ],
      columnStyles: {
        0: { cellWidth: 40 },
        fontSize: 5,
      },
      bodyStyles: {
        lineWidth: 0.2,
        lineColor: [73, 138, 159],
        fontSize: 8,
      },
      theme: "grid",
      tableLineColor: [255, 255, 255],
      tableLineWidth: 1,
    });

    const primera_tabla = doc.lastAutoTable.finalY;
    // doc.autoTable({
    //   head: [
    //     [
    //       {
    //         content: "ACCIÓN TÉCNICA / COORDINATIVA",
    //         styles: { halign: "center", fillColor: [244, 247, 249] }
    //       },
    //       {
    //         content: "INTENCIÓN TÁCTICA / PRINCIPIO COLECTIVO",
    //         styles: { halign: "center", fillColor: [244, 247, 249] }
    //       }
    //     ]
    //   ],
    //   styles: {
    //     lineColor: [73, 138, 159],
    //     lineWidth: 0.2
    //   },
    //   theme: "plain",
    //   startY: primera_tabla
    // });

    if (typeof doc.putTotalPages === "function") {
      doc.putTotalPages(totalPaginas);
    }

    doc.setFontSize(8);
    const pages = doc.internal.getNumberOfPages();
    doc.setProperties({
      title: "Report",
    });

    for (let j = 1; j < pages + 1; j++) {
      let horizontalPos = pageWidth / 2; //Can be fixed number
      let verticalPos = pageHeight - 10; //Can be fixed number
      doc.setPage(j);
      doc.text(`${j} de ${pages}`, horizontalPos, verticalPos, {
        align: "center", //Optional text styling});
      });
    }

    const safeSite = siteName ? `_${siteName.replace(/\s+/g, "_")}` : "";
    doc.save(`reporte_${t(module)}${safeSite}_${year}.pdf`);
  };

  return generatePdf();
}
